import api from "core/api/api";
import utils from "core/utils";
import store from "src/stores/redux/store";

const MAX_NUMBER_OF_EVENTS = 100;

class StreamDataLoader {
    streamName: string = "";
    previewSourceName: string = "";
    data: any[];
    isRunning: boolean;
    numberOfEvents: number = 0;

    constructor() {
        this.data = [];
        this.isRunning = false;
        this.numberOfEvents = 0;
    }
    setStreamName(streamName: string) {
        this.streamName = streamName;
    }
    start() {
        this.data = [];
        store.dispatch({
            type: "CLEAR_STREAM_PREVIEW_DATA"
        });
        this.isRunning = true;
        this.numberOfEvents = 0;
        try {
            api.showStream(this.streamName, MAX_NUMBER_OF_EVENTS);
            this.isRunning = true;
        } catch (error) {
            this.isRunning = false;
            console.error("Error starting stream preview:", error);
        }
    }
    stop() {
        if (!this.isRunning) {
            return;
        }
        this.isRunning = false;
        this.numberOfEvents = 0;
        this.data = [];
        this.streamName = "";
        this.previewSourceName = "";
    }

    listen(streamName: string, event: any) {
        if (!event || !this.isRunning || streamName.toLocaleLowerCase() !== this.streamName.toLocaleLowerCase()) {
            return;
        }
        const data = event.event?.data ?? event.data;
        store.dispatch({
            type: "UPDATE_STREAM_PREVIEW_DATA",
            payload: data
        });
    }
}

const streamDataLoader = new StreamDataLoader();

export default streamDataLoader;
